import React, { createContext, useContext, useMemo, useState } from 'react';
import { Audience } from '../../config/brand';

type AudienceValue = {
  audience: Audience;
  setAudience: (next: Audience) => void;
};

const AudienceContext = createContext<AudienceValue>({
  audience: 'all',
  setAudience: () => {},
});

/**
 * Which visitor track the page is showing. Work and services both read it, so
 * a CTO who picks "For scale-ups" at the top of the work grid keeps that track
 * all the way down the page — and never lands on consumer 0→1 work.
 */
export const AudienceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [audience, setAudience] = useState<Audience>('all');
  const value = useMemo(() => ({ audience, setAudience }), [audience]);
  return <AudienceContext.Provider value={value}>{children}</AudienceContext.Provider>;
};

export const useAudience = () => useContext(AudienceContext);
